import agent from '../agent'
import React from 'react'
import { connect } from 'react-redux'
import { APP_LOAD, REDIRECT, LOGOUT } from '../constants/actionTypes'
import { Route, Switch, Link, withRouter } from 'react-router-dom'
import Register from './Register';
import RegisterSuccess from './RegisterSuccess'
import Login from '../components/Login'
import Verification from '../components/Verification'
import VerifiyPin from '../components/VerifiyPin'
import Home from '../components/Home'
import Cart from '../components/Cart'
import Transactions from '../components/Transactions'
import Transaction from '../components/Transaction'
import Settings from '../components/Settings'
import Pay from '../components/Pay'
import ProductAdd from '../components/ProductAdd'
import ProductEdit from '../components/ProductEdit'
import ProductManage from '../components/ProductManage'
import CategoryAdd from '../components/CategoryAdd'
import CategoryEdit from '../components/CategoryEdit'
import CategoryManage from '../components/CategoryManage'
import { Helmet } from "react-helmet"

import { store } from '../store'
import { push } from 'react-router-redux'
import { BASE_COIN_SYMBOL, SITE_SYMBOL } from '../constants/config'

import { } from '../constants/actionTypes'


const mapStateToProps = state => {
  return {
    appLoaded: state.common.appLoaded,
    appName: state.common.appName,
    orgName: state.common.orgName,
    currentUser: state.common.currentUser,
    redirectTo: state.common.redirectTo
  }
}

const mapDispatchToProps = dispatch => ({
  onLoad: (payload, token) =>
    dispatch({ type: APP_LOAD, payload, token, skipTracking: true }),
  onRedirect: () =>
    dispatch({ type: REDIRECT }),
  onClickLogout: () => dispatch({ type: LOGOUT })
})

class App extends React.Component {
  componentWillReceiveProps(nextProps) {
    if (nextProps.redirectTo) {
      store.dispatch(push(nextProps.redirectTo))
      this.props.onRedirect()
    }
  }

  async componentWillMount() {
    const token = window.localStorage.getItem('pellar-merchant-web-token')
    if (token) {
      agent.setToken(token)
    }
    const payload = token ? agent.Auth.current() : null

    this.props.onLoad(payload, token)
  }


  render() {
    if (this.props.appLoaded) {

      const icoUrl = `/favicon/favicon.ico`
      const clientCSSUrl = `/style/${SITE_SYMBOL.toLowerCase()}.css`
      let applicationVersion

      try { applicationVersion = process.env.npm_package_version || require('../../package.json').version } catch (err) { applicationVersion = 'N/A' }

      return (
        <div>
          <Helmet>
            <meta charSet="utf-8" />
            <title>Merchant POS</title>
            <meta name="viewport" content="width=device-width, initial-scale=1"></meta>
            <link rel="canonical" href="/" />
            <link rel="icon" type="image/x-icon" sizes="16x16" href={icoUrl} />
            <link rel="stylesheet" href="/style/main.css" />
            <link rel="stylesheet" href={clientCSSUrl} />
            <link href="https://fonts.googleapis.com/css?family=Noto+Sans" rel="stylesheet" type="text/css" />
            <link href="https://code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" rel="stylesheet" type="text/css" />
            <link href="https://unpkg.com/ionicons@4.4.6/dist/css/ionicons.min.css" rel="stylesheet" />
          </Helmet>
          <div id="header"><div id="header-wrap">
            {this.props.currentUser ? <Link className='CartIcon' to="/cart"><i className="icon ion-ios-cart"></i></Link> : null}
            <Link to="/"><h1>{this.props.appName}</h1></Link>
          </div></div>
          <Switch>
            <Route exact path="/login" component={Login} />
            <Route exact path="/register" component={Register} />
            <Route exact path="/registersuccess" component={RegisterSuccess} />
            <Route exact path="/verification" component={Verification} />
            <Route exact path="/verifypin" component={VerifiyPin} />
            <Route exact path="/cart" component={Cart} />
            <Route exact path="/pay" component={Pay} />
            <Route exact path="/transactions" component={Transactions} />
            <Route exact path="/transaction/:address" component={Transaction} />
            <Route exact path="/settings" component={Settings} />
            <Route exact path="/" component={Home} />
            <Route exact path="/products/add" component={ProductAdd} />
            <Route exact path="/product/edit/:key" component={ProductEdit} />
            <Route exact path="/products/manage" component={ProductManage} />
            <Route exact path="/categories/add" component={CategoryAdd} />
            <Route exact path="/category/edit/:key" component={CategoryEdit} />
            <Route exact path="/categories/manage" component={CategoryManage} />
          </Switch>
          <div id="footer"><div id="footer-wrap">
            {this.props.currentUser && this.props.currentUser.email ? <Link className='LogoutButton' to="/login" onClick={this.props.onClickLogout}>{'Logout'}</Link> : null}
            <h2>{this.props.orgName} <strong>{applicationVersion}</strong></h2>
          </div></div>
        </div>
      )
    }
    return (
      <div>
        <div id="modal">
          <h1>{this.props.appName}</h1>
        </div>
      </div>
    )
  }
}


export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App))
